<template>
  <div class="store-body">
    <DineInPageToolbar
      isSearch
      isStatus
      isAddTable
      @setPageSearch="handlePageSearch"
    />
    <DineInDataTable @getTableData="handlePagination"/>
    <DineInPagination @setPagination="handlePagination" />
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import DineInPageToolbar from "@/components/store/dine-in/DineInPageToolbar.vue";
import DineInDataTable from "@/components/store/dine-in/DineInDataTable.vue";
import DineInPagination from "@/components/store/dine-in/DineInPagination.vue";
import _ from "lodash";

export default defineComponent({
  components: { DineInPageToolbar, DineInDataTable, DineInPagination },
  setup(props, { root }) {
    const searchPayload = ref({
      no_or_rows: 10,
    });

    const applySearchPayload = (page = 1) => {
      const params = {
        page: page,
      };
      if (!_.isEmpty(searchPayload.value))
        params["payload"] = { ...searchPayload.value };
      root.$store.dispatch("storeDineIn/getGroupTable", params);
    };

    const handlePageSearch = (payload) => {
      searchPayload.value = { ...payload };
      applySearchPayload();
    };

    const handlePagination = (page) => {
      applySearchPayload(page);
    };

    applySearchPayload();

    return {
      handlePageSearch,
      handlePagination,
    };
  },
});
</script>
